import React, { Component } from "react";
import Addproductcontent from "../../sections/Addproduct/Addproductcontent";

class EditMenu extends Component {
  render() {
    return (
      <Addproductcontent />   
    );
  }
}

export default EditMenu;

